import '@mantine/core/styles.css';
import { lazy, useEffect } from 'react';

import { setApiDefaults } from '../App';
import { Loadable } from '../functions/loading';

const DesktopAppView = Loadable(
  lazy(() => import('./DesktopAppView')),
  true,
  true
);

// Main App
export default function MainView() {
  // Set initial login status
  useEffect(() => {
    try {
      // Local state initialization
      setApiDefaults();
    } catch (e) {
      console.error(e);
    }
  }, []);

  // Beagle: the upstream mobile-viewport gate (checkMobile() -> <MobileAppView/>)
  // is removed. The Beagle Inventory UI is used on phones for stock in/out, so
  // always render the desktop app regardless of viewport size.
  return <DesktopAppView />;
}
